<section>
  <h2 class="header-title">
    <cw-icon
      class="icon mobile-drawer-toggle"
      [icon]="headerService.toggleMobileMenu() ? 'close' : 'menu'"
      size="md"
      font="cortex"
      (click)="openMobileMenuClicked()"
    />

    @if (statusService.status()?.id === status.APP_UNAVAILABLE) {
      {{ 'AppTitle' | translate }}
    } @else {
      <span class="header-title-text">
        {{ 'AppTitle' | translate }}
      </span>
    }
  </h2>
</section>
<section>
  <div class="left-actions">
    <div
      [attr.data-vef]="'header-notifications-button'"
      class="alarm"
      [ngClass]="store.criticality()"
      (click)="$event.stopPropagation(); alarmClicked()"
    >
      <cw-icon font="cortex" icon="notification-active" size="md" />

      @if (store.count()) {
        <cw-badge-notification
          class="badge-notification"
          [ngClass]="['animate-badge', store.criticality()]"
          size="lg"
          >{{ store.count() }}</cw-badge-notification
        >
      }
    </div>

    <!-- Connections status -->
    @if (ws.alive() && network.online() && jobStore.connectionType() === connectionType.WS) {
      <cw-tooltip
        [attr.data-vef]="'topBar-system-status-label'"
        [content]="'SystemStatusConnected' | translate"
        placement="bottom"
      >
        <cw-icon font="cortex" icon="cloud-done" size="md" />
      </cw-tooltip>
    } @else if (
      (!ws.alive() && jobStore.connectionType() === connectionType.WS && !ws.connecting()) || !network.online()
    ) {
      <cw-tooltip
        [attr.data-vef]="'topBar-system-status-label'"
        [content]="'SystemStatusDisconnected' | translate"
        placement="bottom"
      >
        <cw-icon font="cortex" icon="cloud-off" size="md" />
      </cw-tooltip>
    }

    <!-- Connecting -->
    @if (!ws.alive() && jobStore.connectionType() === connectionType.WS && ws.connecting()) {
      <cw-tooltip
        [attr.data-vef]="'topBar-system-connecting-status-label'"
        [content]="'SystemStatusConnecting' | translate"
        placement="bottom"
      >
        <gplus-icon-cloud-loading />
      </cw-tooltip>
    }

    @if (jobStore.connectionType() === connectionType.POLLING) {
      <cw-tooltip
        [attr.data-vef]="'topBar-system-polling-status-label'"
        [content]="
          'DataLastUpdatedAt' | translate: { time: jobStore.lastUpdated() | localizedDate: dateFormat.SHORT_TIME }
        "
        placement="bottom"
      >
        <gplus-icon-cloud-sync />
      </cw-tooltip>
    }

    <gplus-user class="header-user" />
  </div>
</section>
